import { extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';

var ChevronRight = function ChevronRight(props) {
  var rtlStyle = {
    transform: 'scale(-1, 1)'
  };
  var _props$color = props.color,
      color = _props$color === void 0 ? 'currentColor' : _props$color,
      size = props.size,
      _props$dir = props.dir,
      dir = _props$dir === void 0 ? 'ltr' : _props$dir,
      style = props.style;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: dir === 'rtl' ? _extends({}, style, rtlStyle) : _extends({}, style)
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M15.5858 12L8.29289 4.70711C7.90237 4.31658 7.90237 3.68342 8.29289 3.29289C8.68342 2.90237 9.31658 2.90237 9.70711 3.29289L17.7071 11.2929C18.0976 11.6834 18.0976 12.3166 17.7071 12.7071L9.70711 20.7071C9.31658 21.0976 8.68342 21.0976 8.29289 20.7071C7.90237 20.3166 7.90237 19.6834 8.29289 19.2929L15.5858 12Z",
    fill: color
  }));
};

export { ChevronRight };
